import React from "react";
import Menu from "./Menu";

// Premium Theme Palette
const THEME = {
    BG_DARK: "#06362D",
    PANEL_DARK: "#06362D",
    DEEP_DARK: "#04241E",
    BORDER_DARK: "#D1A505",
    TEXT_PRIMARY: "#DEE2B1",
    TEXT_SECONDARY: "#D1A505",
    ACCENT_GOLD: "#FFD500",
    STRICT_DARK_BORDER: "rgba(0, 0, 0, 0.5)",
    DANGER: "#EF4444",
    DANGER_BG: "rgba(239, 68, 68, 0.15)",
    SUCCESS: "#10B981",
    SUCCESS_BG: "rgba(16, 185, 129, 0.15)",
    WARNING: "#F59E0B",
    WARNING_BG: "rgba(245, 158, 11, 0.15)"
};

function Notfound() {
    return (
        <div
            style={{
                display: "flex",
                minHeight: "100vh",
                backgroundColor: THEME.BG_DARK,
                color: THEME.TEXT_PRIMARY
            }}
        >
            {/* Optional Left Menu Component */}
            {/* <Menu /> */}

            {/* RIGHT CONTENT */}
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "20px"
                }}
            >
                <div
                    style={{
                        padding: "50px",
                        borderRadius: "16px",
                        backgroundColor: THEME.DEEP_DARK,
                        border: `1px solid ${THEME.BORDER_DARK}`,
                        boxShadow: `0 8px 32px ${THEME.STRICT_DARK_BORDER}`,
                        maxWidth: "500px",
                        width: "100%"
                    }}
                >
                    <h1
                        style={{
                            fontSize: "90px",
                            margin: "0",
                            fontWeight: "800",
                            color: THEME.ACCENT_GOLD,
                            letterSpacing: "-0.03em",
                            lineHeight: 1
                        }}
                    >
                        404
                    </h1>

                    <h2
                        style={{
                            fontSize: "26px",
                            marginTop: "16px",
                            fontWeight: "700",
                            color: THEME.TEXT_PRIMARY
                        }}
                    >
                        Page Not Found
                    </h2>

                    <p
                        style={{
                            fontSize: "15px",
                            marginTop: "12px",
                            color: THEME.TEXT_PRIMARY,
                            opacity: 0.8,
                            lineHeight: "1.6"
                        }}
                    >
                        The page you are looking for doesn’t exist or was moved.
                    </p>

                    {/* BACK TO HOME BUTTON */}
                    <a
                        href="/home"
                        style={{
                            display: "inline-block",
                            marginTop: "28px",
                            padding: "12px 30px",
                            background: `linear-gradient(135deg, ${THEME.ACCENT_GOLD}, ${THEME.BORDER_DARK})`,
                            color: THEME.DEEP_DARK,
                            fontSize: "15px",
                            fontWeight: "800",
                            borderRadius: "30px",
                            textDecoration: "none",
                            boxShadow: "0 4px 15px rgba(255, 213, 0, 0.3)",
                            transition: "all 0.3s ease",
                            cursor: "pointer"
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = "translateY(-3px)";
                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(255, 213, 0, 0.45)";
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = "translateY(0px)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(255, 213, 0, 0.3)";
                        }}
                    >
                        ⬅ Back to Home
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Notfound;